import axios from 'axios'
import { host } from '../../helper/config'

const PLUGINS_NAME = 'admin-withdraw-setting'

export const getMinBankWithdraw = async (token) => {
  const response = await axios.get(`${host}/${PLUGINS_NAME}/get`, {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'Authorization': token
    },
  })

  if (response && response.status === 200 && response.data) {
    return response.data.minBankWithdraw ?? 200000
  }
  return 200000
}

export const updateMinBankWithdraw = async (token, minBankWithdraw) => {
  const response = await axios.post(`${host}/${PLUGINS_NAME}/update`, {
    minBankWithdraw
  }, {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'Authorization': token
    },
  })

  if (response && response.status === 200) {
    return response.data
  }
  return null
}
